import { createSelector } from 'reselect'
import { compact, mapValues, omit, pick } from 'lodash'

/**
 * getMapSelector
 * @param  {String or Function} mapParam - any values you could pass to mapValues
 * @return {Object} Any value that would be retured by maps values
 *
 * Essentially iterates over the homePreview state branch and returns the desired
 * data mapped to ID
 */
const getMapSelector = mapParam =>
  createSelector(
    state => omit(state.homePreview, 'customerProfile'),
    homePreview => mapValues(homePreview, mapParam)
  )

export const selectAirDnaAddressMap = getMapSelector(({ data }) => {
  if (!data) {
    return undefined
  }

  const {
    address: { street, unit, zip }
  } = data
  return {
    address: compact([street, unit && `#${unit}`]).join(' '),
    zipcode: zip
  }
})

export const selectCurrentAVMMap = getMapSelector('data.currentAVM')
export const selectAddressMap = getMapSelector('data.address')
export const selectSubmittedStateMap = getMapSelector(record =>
  pick(record, 'submitting', 'submitted')
)
